import React from "react";

const Backdrop = (props) => {
  return props.show ? (
    <div
      className={"Backdrop"}
      onClick={(e) => {
        props.toggle(false);
        e.stopPropagation();
      }}
      style={{
        backgroundColor: props.backgroundColor
          ? "rgba(0,0,0,0.5)"
          : "transparent",
      }}
    ></div>
  ) : null;
};

export default Backdrop;
